// /components/routes/Dashboard/Dashboard.tsx
import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { supabase } from '../../../helpers/Supabase';
import Loader from '../../Loader/Loader';
import ClientHeader from './ClientHeader';
import StoreMap from './StoreMap';
import SentimentCharts from './SentimentCharts';
import UpgradeModal from './UpgradeModal';
import '../../../styles/components/Dashboard.scss';
import SurveyList from './SurveyList';
import GptInsights from './GptInsights';

const Dashboard: React.FC = () => {
  const [clientName, setClientName] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [, setConversations] = useState<any[]>([]);
  const [storeId, setStoreId] = useState<string | null>(null);
  const [, setClientId] = useState<string>('');

  const history = useHistory();

  useEffect(() => {
    const fetchClientInfo = async () => {
      const { data: { user }, error } = await supabase.auth.getUser();
      if (error || !user) return history.push('');

      const { data: userRows } = await supabase
        .from('users')
        .select('client_id')
        .eq('auth_user_id', user.id)
        .order('created_at', { ascending: false })
        .limit(1);

      const userRow = userRows && userRows.length > 0 ? userRows[0] : null;
      console.log('🔍 Dashboard checking user:', userRow);
      
      if (!userRow?.client_id) {
        console.log('❌ No client_id found, redirecting to complete-profile');
        return history.push('/complete-profile');
      }
      
      console.log('✅ User has client_id:', userRow.client_id);

      const { data: clientRow } = await supabase
        .from('clients')
        .select('name, logo_url')
        .eq('id', userRow.client_id)
        .single();

      setClientName(clientRow?.name || '');
      setLogoUrl(clientRow?.logo_url || '');
      setClientId(userRow.client_id);
      setIsLoading(false);
    };

    fetchClientInfo();
  }, [history]);

  const handleSurveysLoaded = useCallback((surveys: any[]) => {
    if (surveys.length > 0) {
      setStoreId(surveys[0].store_id || null); // ✅ Extract from first survey
      setConversations(surveys.map((survey) => survey.responses || []));
    }
  }, []);

  if (isLoading) return <Loader />;

  return (
    <div className="dashboard">
      {showUpgradeModal && <UpgradeModal onClose={() => setShowUpgradeModal(false)} />}

      <ClientHeader name={clientName} logoUrl={logoUrl} />

      <div className="ai-btn-container">
        <GptInsights storeId={storeId || ''} />
      </div>

      <div className="dashboard-main-grid">
        <div className="dashboard-left">
          <StoreMap />
          {/* <SentimentCharts /> */}
        </div>
        <div className="dashboard-right">
          <SentimentCharts />
        </div>
      </div>

<section className="surveys-section">
  <SurveyList onSurveysLoaded={handleSurveysLoaded} />
</section>

{/* Reviews Section */}
{/* {clientId && <ReviewsSection clientId={clientId} />} */}

    </div>
  );
};

export default Dashboard;
